

























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import UserReview from './UserReview.vue'

@Component({
  components: {
    UserReview,
  },
})
export default class Pagination extends Vue {
  @Prop({ required: true })
  disabled: boolean

  @Prop({ required: true })
  totalPageNumber: number

  @Prop({ required: true })
  currentPageNumber: number

  get hasPreviousPage(): boolean {
    return this.currentPageNumber > 1
  }

  get hasNextPage(): boolean {
    return this.currentPageNumber < this.totalPageNumber
  }
}
